import React from "react";
import "./White_Btn.css";

const White_Btn = ({ btnText, onClick , className  }) => {
  return (
    <button    className={`White_Btn ${className}`} onClick={onClick}>
      {btnText}
    </button>
  );
};

export default White_Btn;
